import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-6 border-b border-gray-200 dark:border-gray-700 flex flex-col items-center gap-6 md:flex-row md:gap-8 md:items-center" }
const _hoisted_2 = { class: "flex flex-col items-center justify-center flex-shrink-0" }
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = { class: "h-32 w-32 rounded-full bg-gray-200 dark:bg-gray-600 flex items-center justify-center overflow-hidden" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 1,
  class: "text-gray-500 dark:text-gray-200 text-4xl font-medium"
}
const _hoisted_7 = { class: "flex-1 w-full grid grid-cols-1 sm:grid-cols-3 gap-4" }
const _hoisted_8 = { class: "text-lg font-semibold text-gray-900 dark:text-white break-words" }
const _hoisted_9 = { class: "text-lg font-semibold text-gray-900 dark:text-white break-words" }
const _hoisted_10 = { class: "text-lg font-semibold text-gray-900 dark:text-white break-words" }
const _hoisted_11 = { class: "p-6" }
const _hoisted_12 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_13 = { class: "text-base text-gray-900 dark:text-white break-words" }
const _hoisted_14 = { class: "text-base text-gray-900 dark:text-white break-words" }
const _hoisted_15 = { class: "md:col-span-2" }
const _hoisted_16 = { class: "text-base text-gray-900 dark:text-white break-words" }
const _hoisted_17 = { class: "p-6 border-t border-gray-200 dark:border-gray-700" }
const _hoisted_18 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4" }
const _hoisted_19 = { class: "text-base text-gray-900 dark:text-white break-words" }
const _hoisted_20 = { class: "text-base text-gray-900 dark:text-white break-words" }
const _hoisted_21 = { class: "text-base text-gray-900 dark:text-white break-words" }

import { User } from 'lucide-vue-next'
import { watch, ref, computed } from 'vue'
import BaseModal from '@/components/common/BaseModal.vue'
import BaseButton from '@/components/common/BaseButton.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ViewEmployeeDetails',
  props: {
  isVisible: {
    type: Boolean,
    required: true
  },
  employee: {
    type: Object,
    required: false,
    default: null
  }
},
  emits: ['close', 'image-error'],
  setup(__props, { emit: __emit }) {

const props = __props


const emit = __emit

// local flag to show placeholder if image fails to load
const imageErrored = ref(false)

const handleImageError = (event: Event) => {
  imageErrored.value = true
  emit('image-error', event)
}

const closeModal = () => {
  emit('close')
}

// Reset image error flag when employee changes
watch(
  () => props.employee,
  () => {
    imageErrored.value = false
  }
)

// Compute initials from available name fields (handles single-field full names)
const initials = computed(() => {
  const first = props.employee?.first_name?.toString().trim() || ''
  const last = props.employee?.last_name?.toString().trim() || ''

  if (first && last) {
    return (first.charAt(0) + last.charAt(0)).toUpperCase()
  }

  const nameSource = (first || props.employee?.email || '') as string
  if (nameSource) {
    const parts = nameSource.split(/\s+/).filter(Boolean)
    if (parts.length >= 2) {
      return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase()
    }
    return parts[0].charAt(0).toUpperCase()
  }

  return ''
})

const formatDate = (dateStr?: string): string => {
  if (!dateStr) return 'N/A'
  try {
    const date = new Date(dateStr)
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })
  } catch {
    return dateStr
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    "is-visible": __props.isVisible,
    title: "View Employee Details",
    subtitle: `${__props.employee?.first_name || 'employee'}'s information`,
    icon: _unref(User),
    size: "2xl",
    type: "default",
    "show-footer": true,
    onClose: closeModal
  }, {
    footer: _withCtx(() => [
      _createVNode(BaseButton, {
        text: "Close",
        variant: "primary",
        onClick: closeModal
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (__props.employee?.user_image && !imageErrored.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: __props.employee.user_image,
                    alt: `${__props.employee.first_name} ${__props.employee.last_name}`,
                    class: "h-full w-full object-cover",
                    onError: handleImageError
                  }, null, 40, _hoisted_5))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(initials.value || (__props.employee?.first_name?.charAt(0) || '') + (__props.employee?.last_name?.charAt(0) || '')), 1))
            ]),
            _createElementVNode("span", {
              class: _normalizeClass([
              'absolute bottom-1 right-4 block h-6 w-6 rounded-full ring-2 ring-white',
              __props.employee?.status === 'Active' ? 'bg-green-500' : 'bg-red-500'
            ]),
              "aria-hidden": "true"
            }, null, 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _cache[0] || (_cache[0] = _createElementVNode("label", { class: "block text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1" }, "First Name", -1)),
            _createElementVNode("p", _hoisted_8, _toDisplayString(__props.employee?.first_name || 'N/A'), 1)
          ]),
          _createElementVNode("div", null, [
            _cache[1] || (_cache[1] = _createElementVNode("label", { class: "block text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1" }, "Middle Name", -1)),
            _createElementVNode("p", _hoisted_9, _toDisplayString(__props.employee?.middle_name || 'N/A'), 1)
          ]),
          _createElementVNode("div", null, [
            _cache[2] || (_cache[2] = _createElementVNode("label", { class: "block text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1" }, "Last Name", -1)),
            _createElementVNode("p", _hoisted_10, _toDisplayString(__props.employee?.last_name || 'N/A'), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "font-bold text-lg mb-4 dark:text-white" }, "Contact Information", -1)),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", null, [
            _cache[3] || (_cache[3] = _createElementVNode("label", { class: "block text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1" }, "Email Address", -1)),
            _createElementVNode("p", _hoisted_13, _toDisplayString(__props.employee?.email || 'N/A'), 1)
          ]),
          _createElementVNode("div", null, [
            _cache[4] || (_cache[4] = _createElementVNode("label", { class: "block text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1" }, "Phone Number", -1)),
            _createElementVNode("p", _hoisted_14, _toDisplayString(__props.employee?.phone_number || 'N/A'), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[5] || (_cache[5] = _createElementVNode("label", { class: "block text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1" }, "Date Added", -1)),
            _createElementVNode("p", _hoisted_16, _toDisplayString(formatDate(__props.employee?.created_at) || 'N/A'), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "font-bold text-lg mb-4 dark:text-white" }, "Address", -1)),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", null, [
            _cache[7] || (_cache[7] = _createElementVNode("label", { class: "block text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1" }, "City", -1)),
            _createElementVNode("p", _hoisted_19, _toDisplayString(__props.employee?.city || 'N/A'), 1)
          ]),
          _createElementVNode("div", null, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { class: "block text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1" }, "State", -1)),
            _createElementVNode("p", _hoisted_20, _toDisplayString(__props.employee?.state || 'N/A'), 1)
          ]),
          _createElementVNode("div", null, [
            _cache[9] || (_cache[9] = _createElementVNode("label", { class: "block text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1" }, "ZIP Code", -1)),
            _createElementVNode("p", _hoisted_21, _toDisplayString(__props.employee?.zip_code || 'N/A'), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["is-visible", "subtitle", "icon"]))
}
}

})